/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
export default class SignupTeamsIndex extends Route {
  @service windowLocationService;
  beforeModel(transition) {
    let queryParams = transition.to.queryParams;

    let currentParams = new URLSearchParams(queryParams);
    currentParams.set('from_embercom', true);
    if (!currentParams.has('from_embercom_route')) {
      currentParams.set('from_embercom_route', 'signup/teams/index');
    }
    let signupParams = currentParams.toString();

    // Only if developer is true, redirect to developer signup
    if (currentParams.get('developer') === 'true') {
      this.windowLocationService.replace(`admins/sign_up/developer?${signupParams}`);
    } else {
      this.windowLocationService.replace(`admins/sign_up?${signupParams}`);
    }
  }
}
